import { toast } from "sonner";

export function showToast(type: "success" | "error", message: string) {
  toast(message, {
    duration: 5000,
    icon: type === "success" ? "✅" : "❌",
    style: {
      background: type === "success" ? "#1B3C8E" : "#E53935",
      color: "#fff",
    },
  });
}
